import { render, staticRenderFns } from "./aboutour.vue?vue&type=template&id=e4052334&scoped=true&"
import script from "./aboutour.vue?vue&type=script&lang=js&"
export * from "./aboutour.vue?vue&type=script&lang=js&"
import style0 from "./aboutour.vue?vue&type=style&index=0&id=e4052334&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4052334",
  null
  
)

export default component.exports